import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { WINDOW } from 'src/app/core/core.module';
import { ContractRequestFilter } from '../models/contract-request-filter.model';
import { DuplicateContractRequestKey } from '../enum/duplicate-contract-request-key.enum';
import { ReviewAndSendReason } from '../models/review-and-send-reason.model';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgIf, NgFor } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'existing-contract-request-dialog',
    templateUrl: './existing-contract-request.dialog.component.html',
    styleUrls: ['./dialog-styles.scss', './existing-contract-request.dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, NgIf, MatSelectModule, NgFor, MatOptionModule, MatButtonModule]
})
export class ExistingContractRequestDialog implements OnInit {
    isLoading = false;
    contractRequestFilter: ContractRequestFilter;
    selectedReason: string;

    reasons: ReviewAndSendReason[] = [
        {
            key: DuplicateContractRequestKey.ReviewAndSend,
            name: 'This request is for a different contract than one that currently exists'
        },
        {
            key: DuplicateContractRequestKey.ViewExistingRequest,
            name: 'This request is to adjust/correct/add to one that currently exists'
        }
    ];

    constructor(
        private readonly dialogRef: MatDialogRef<ExistingContractRequestDialog>,
        @Inject(WINDOW) private readonly window: Window,
        @Inject(MAT_DIALOG_DATA)
        public data: { candidateName: string; facility: string; contractRequestCount: number; marginId: number }
    ) {}

    ngOnInit(): void {
        this.contractRequestFilter = this.data;
    }

    public close(): void {
        this.dialogRef.close(null);
    }

    public continueToReviewAndSend(): void {
        this.dialogRef.close(DuplicateContractRequestKey.ReviewAndSend);
    }

    public viewExistingContractRequests(): void {
        this.dialogRef.close(DuplicateContractRequestKey.ViewExistingRequest);
        localStorage.setItem('margincalc.contractrequest.filter', JSON.stringify(this.contractRequestFilter));
        this.window.open(`#/recruiting/contract-requests-new`, '_blank');
    }
}
